/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import { getRequest, postRequest, putRequest } from "../../helpers/Api";
import { types } from "../reducers/users";
import { userNotAuthorizedHandler } from "./authentication";

function* storeUser({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(payload.id ? putRequest : postRequest, {
      url: payload.id ? `/users/${payload.id}` : "/users",
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.user),
    });

    if (res.status === 409) {
      /*
      const errorMessage =
        res.response && res.response.message
          ? res.response.message
          : res.message === "Conflict"
          ? "User already exists"
          : res.message;
      payload.onFailure(errorMessage, {
        errors: [
          {
            key: res.response && res.response.field ? res.response.field : "description",
            error: errorMessage,
          },
        ],
      });
      */
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({
        type: types.FETCH_USER_REQUEST,
        payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
      });
    } else {
      payload.onFailure(res.message);
    }
  } catch (err) {
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

/**
 * Fetch users when filters are changed
 */
function* fetchUsersRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const { page: prevPage, perPage: prevPerPage, qs: prevQs } = yield select((state) => state.users);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(getRequest, {
    url: `/users?${params.toString()}`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    const users = response.result.map((user) => {
      switch (typeof user.status) {
        case "string": {
          if (user.status === "active") {
            user.status = "1";
          } else {
            user.status = "0";
          }
          break;
        }
        case "boolean":
        case "number":
        default: {
          if (user.status) {
            user.status = "1";
          } else {
            user.status = "0";
          }
          break;
        }
      }
      return user;
    });
    yield put({ type: types.ADD_USERS, payload: { users } });
    yield put({
      type: types.SET_USER_TOTAL_ITEMS,
      payload: {
        totalItems: response.totalItems,
      },
    });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}

export default function* sagas() {
  yield takeEvery(types.ADD_USER, storeUser);
  yield takeEvery(types.UPDATE_USER, storeUser);
  yield takeEvery(types.FETCH_USER_REQUEST, fetchUsersRequest);
}
